import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareCardSizeMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  cardSize?: Types.InputMaybe<Types.AssetAggregateCardSizeEnum>;
}>;


export type UpdateShareCardSizeMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, appearance: { __typename?: 'AssetAggregateAppearance', cardSize: Types.AssetAggregateCardSizeEnum } } | { __typename?: 'CollectionShare', id: string, appearance: { __typename?: 'AssetAggregateAppearance', cardSize: Types.AssetAggregateCardSizeEnum } } | null } | null };


export const UpdateShareCardSize = /*#__PURE__*/ gql`
    mutation UpdateShareCardSize($shareId: ID!, $cardSize: AssetAggregateCardSizeEnum) {
  updateShare(input: {shareId: $shareId, appearance: {cardSize: $cardSize}}) {
    share {
      id
      ... on AssetAggregate {
        appearance {
          cardSize
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareCardSizeMutation, UpdateShareCardSizeMutationVariables>;

          

          export const useUpdateShareCardSizeMutation = (options?:MutationHookOptions<UpdateShareCardSizeMutation, UpdateShareCardSizeMutationVariables>) => useMutation(UpdateShareCardSize, options);
          

          export type UpdateShareCardSizeMutationOptions = MutationHookOptions<UpdateShareCardSizeMutation, UpdateShareCardSizeMutationVariables>;

          

          export type UpdateShareCardSizeMutationResult = ReturnType<typeof useUpdateShareCardSizeMutation>[1];

          
